import React from "react";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const About = () => {
  const content = useContent();
  const { lang } = useLang();
  const e = ext[lang];
  const text = content ? (lang === "ro" ? content.about_ro : content.about_en) : "";
  return (
    <main className="mx-auto max-w-2xl px-4 py-16 sm:px-6" data-testid="about-page">
      <h1 className="text-3xl uc font-semibold sm:text-4xl">{e.about}</h1>
      <p className="mt-6 whitespace-pre-line text-base leading-relaxed text-muted-foreground">{text}</p>
    </main>
  );
};

export default About;
